<template>
  <div>
    <div class="question-pages" v-for="(question, index) in questions">
      <Question
        :answers="question.answers"
        :question-title="question.title"
        :question-sub-title="question.subTitle"
        :question-number="index"
        :user-answers="userAnswers"
        @click="click"
      />
    </div>
  </div>
</template>

<script>
import Question from "./Question";

export default {
  name: 'QuestionPage',
  components: {
    Question
  },
  data() {
    return {
      userAnswers: [],
      questions: [
        {
          title: "お子さまの朝の<br>目覚めについて",
          answers: [
            "中々起きることができない",
            "声をかけると起きる",
            "自分で起きることができる",
            "自分で毎日同じ時間に起きる@small",
          ],
          subTitle: null
        },
        {
          title: "あさごはんについて",
          answers: [
            "いつも食べない",
            "食べないときもある - 週１~２@small",
            "残す時がある",
            "毎日残さず食べる",
          ],
          subTitle: null
        },
        {
          title: "日常的な<br>運動習慣について",
          answers: [
            "ない",
            "週1回程度",
            "週3回以上",
            "毎日",
          ],
          subTitle: "※1日30分以上の外でのあそびを含む。<br>保育園や体育の授業以外"
        },
        {
          title: "テレビやゲームの<br>時間について",
          answers: [
            "2時間以上",
            "1時間程度",
            "30分程度",
            "ほとんどしない または全くしない@small",
          ],
          subTitle: "※1日あたりの平均時間"
        },
        {
          title: "立位体前屈の<br>柔軟について",
          answers: [
            "手が床につかない",
            "膝を少し曲げたら指が床につく@small",
            "膝を伸ばして指が楽に床につく@small",
            "膝を伸ばして手のひらが床につく@small",
          ],
          subTitle: null
        },
        {
          title: "両手を横に広げた<br>片足立ちについて",
          answers: [
            "片足で立てない",
            "目を開けて片足立ち5秒",
            "目を開けて片足立ち10秒",
            "目を閉じて片足立ち5秒",
          ],
          subTitle: null
        },
      ]
    }
  },
  methods: {
    click({questionNumber, value}) {
      this.$set(this.userAnswers, questionNumber, value)
      scrollTo(0,0);

      if (this.userAnswers.length >= 6) {
        const power1Point = Number(this.userAnswers[0]) + this.userAnswers[1]
        const power2Point = Number(this.userAnswers[2]) + this.userAnswers[3]
        const power3Point = Number(this.userAnswers[4]) + this.userAnswers[5]


        this.$router.push(
          '/answer?power1=' + power1Point
          + '&power2=' + power2Point
          + '&power3=' + power3Point
        )
      }

    }
  },
}
</script>



// WEBPACK FOOTER //
// src/components/QuestionPage.vue